/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_X15_Wrong_GoogleInputs */

const en_auth_x15_wrong_google = /** @type {(inputs: Auth_X15_Wrong_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That Google account uses a different address. Sign in with the invited address, or ask for an invitation to this one.`)
};

/** @type {(inputs: Auth_X15_Wrong_GoogleInputs) => LocalizedString} */
const ar_auth_x15_wrong_google = en_auth_x15_wrong_google;

/** @type {(inputs: Auth_X15_Wrong_GoogleInputs) => LocalizedString} */
const he_auth_x15_wrong_google = en_auth_x15_wrong_google;

/** @type {(inputs: Auth_X15_Wrong_GoogleInputs) => LocalizedString} */
const ur_auth_x15_wrong_google = en_auth_x15_wrong_google;

/** @type {(inputs: Auth_X15_Wrong_GoogleInputs) => LocalizedString} */
const es_auth_x15_wrong_google = en_auth_x15_wrong_google;

/** @type {(inputs: Auth_X15_Wrong_GoogleInputs) => LocalizedString} */
const fr_auth_x15_wrong_google = en_auth_x15_wrong_google;

/** @type {(inputs: Auth_X15_Wrong_GoogleInputs) => LocalizedString} */
const de_auth_x15_wrong_google = en_auth_x15_wrong_google;

/** @type {(inputs: Auth_X15_Wrong_GoogleInputs) => LocalizedString} */
const pt_auth_x15_wrong_google = en_auth_x15_wrong_google;

/** @type {(inputs: Auth_X15_Wrong_GoogleInputs) => LocalizedString} */
const hi_auth_x15_wrong_google = en_auth_x15_wrong_google;

/** @type {(inputs: Auth_X15_Wrong_GoogleInputs) => LocalizedString} */
const bn_auth_x15_wrong_google = en_auth_x15_wrong_google;

/**
* | output |
* | --- |
* | "That Google account uses a different address. Sign in with the invited address, or ask for an invitation to this one." |
*
* @param {Auth_X15_Wrong_GoogleInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const auth_x15_wrong_google = /** @type {((inputs?: Auth_X15_Wrong_GoogleInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_X15_Wrong_GoogleInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_auth_x15_wrong_google(inputs)
	if (locale === "he") return he_auth_x15_wrong_google(inputs)
	if (locale === "ur") return ur_auth_x15_wrong_google(inputs)
	if (locale === "es") return es_auth_x15_wrong_google(inputs)
	if (locale === "fr") return fr_auth_x15_wrong_google(inputs)
	if (locale === "de") return de_auth_x15_wrong_google(inputs)
	if (locale === "pt") return pt_auth_x15_wrong_google(inputs)
	if (locale === "hi") return hi_auth_x15_wrong_google(inputs)
	if (locale === "bn") return bn_auth_x15_wrong_google(inputs)
	return /** @type {LocalizedString} */ ("That Google account uses a different address. Sign in with the invited address, or ask for an invitation to this one.")
});